import React from 'react'

interface ICloudUploadSvg {
  width?: number
  height?: number
  color?: string
}

export const CloudUploadSvg: React.FC<ICloudUploadSvg> = ({
  width = 100,
  height = 80,
  color = 'black',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.8 8.38683C24.8933 3.78683 20.8533 0.333496 16 0.333496C12.1467 0.333496 8.8 2.52016 7.13333 5.72016C3.12 6.14683 0 9.54683 0 13.6668C0 18.0802 3.58667 21.6668 8 21.6668H25.3333C29.0133 21.6668 32 18.6802 32 15.0002C32 11.4802 29.2667 8.62683 25.8 8.38683ZM18.6667 12.3335V17.6668H13.3333V12.3335H9.33333L16 5.66683L22.6667 12.3335H18.6667Z"
      fill={color}
    />
  </svg>
)
